import React from "react";
import { Col, Grid, Image, Row, Table } from "react-bootstrap";
import { attributesActions, employmentActions } from "_actions";
import { connect } from "react-redux";
import { LocationOn } from "@material-ui/icons";
import { calculateRating, generatePhotoLink } from "_helpers";
import userAvatar160 from "components/images/user-160.svg";
import { Link } from "react-router-dom";
import { Loading } from "../common";
import moment from "moment/moment";
import { UserAttributes } from "./UserAttributes";
import styles from "./Styles.module.css";

class ExpertDetails extends React.Component {
    componentDidMount() {
        const { userId } = this.props.match.params;
        this.props.dispatch(employmentActions.getAll({ userId }));
        this.props.dispatch(employmentActions.getEmploymentMetrics({ userId }));
        this.props.dispatch(attributesActions.getAttributes({ userId }));
    }

    renderDetailsRow = (employment) => {
        const { employmentMetrics } = this.props;
        const {id, bio, status, _embedded:{ agent, organization} } = employment;
        let score = agent.score / 5 || 0;

        const matchEmploymentMetrics = employmentMetrics?.employments?.find((data) => data?.id === id);

        return (
            <tr key={id}>
                <td>
                    <Link to={`/company/experts/${id}/show`}>{organization.name}</Link>
                </td>
                <td>{status}</td>
                <td>{bio ? bio: " N/A"}</td>
                <td>{agent.messagesCount}</td>
                <td>{calculateRating(score)}</td>
                <td>{(matchEmploymentMetrics?.recentActivity)
                    ? moment(matchEmploymentMetrics?.recentActivity).format('MMMM Do YYYY, h:mm:ss a')
                    : "N/A"}
                </td>
                <td>{matchEmploymentMetrics?.positiveMessagesCount}</td>
                <td>{matchEmploymentMetrics?.negativeMessagesCount}</td>
            </tr>
        );
    };

    renderEmploymentData = () => {
        const { employmentData } = this.props;
        const { employments = [] } = employmentData;

        if (!employments.length) {
            return (
                <div className={styles.noEmploymentData}>
                    No data
                </div>
            )
        }

        const agent = employments[0]._embedded.agent;

        let photo = userAvatar160;

        if (agent.photo) {
            photo = generatePhotoLink(agent.photo);
        }

        return (
            <>
                <Grid className={styles.plFarRight}>
                    <Link
                        to={"/experts"}
                        className={`btn btn-sm ${styles["backLink"]}`}
                    >
                        <i className="fa fa-arrow-left color-green" />
                    </Link>
                </Grid>
                <Col md={2}>
                    <Grid className={styles.pb50}>
                        <div className="profile-photo-container">
                            <Image responsive src={photo} alt={agent.username} circle />
                        </div>
                    </Grid>
                </Col>
                <Col md={10}>
                    <Grid className={styles.pt40}>
                        <div className={`font-22-bold color-grey-dark tms-ellipsis ${styles["nameHolder"]}`}>
                            {agent.firstName + " " + agent.lastName}
                        </div>
                        <div className={`font-15 color-green tms-ellipsis ${styles["emailHolder"]}`}>
                            {agent.email}
                        </div>
                        <div className="font-15 color-grey-mid tms-ellipsis">
                            <i className="fa fa-phone-square" aria-hidden="true" />
                            {agent.phoneNumber ? agent.phoneNumber: "  N/A"}
                        </div>
                        <div className="font-15 color-grey-mid tms-ellipsis">
                            <i className="fa fa-clock-o" aria-hidden="true" />
                            {agent.timezone ? agent.timezone: "  N/A"}
                        </div>
                        <div className='flex-container'>
                            <div>
                                <LocationOn className={`color-grey-mid ${styles["locationIcon"]}`}/>
                            </div>
                            <div className={`font-15 color-grey-mid tms-ellipsis ${styles["stateHolder"]}`}>
                                {agent.city + ", " + agent.state}
                            </div>
                        </div>
                    </Grid>
                </Col>
            </>
        );
    };

    render() {
        const { employmentData, loadingAttributes, loading } = this.props;
        const { employments } = employmentData;

        return (
            <Grid justify="center">
                <Grid xs={12} sm={12} md={10} className={`shadow-border ${styles.minHeightScreen}`}>
                    <Grid xs={12} md={7}>
                        {loading ? (
                            <div className={styles.expertDetailsLoader}>
                                <Loading height={300} />
                            </div>
                        ) : (
                            <>
                                {employments?.length === 0 ? (
                                    <div className={styles.noData}>
                                        No data
                                    </div>
                                ) : (
                                    <>
                                        <Row className={styles.pt100}>
                                            {this.renderEmploymentData()}
                                        </Row>
                                        <Row>
                                            <Table striped bordered hover className={styles.width95Percent}>
                                                <thead>
                                                <tr>
                                                    <th>Organization</th>
                                                    <th>Status</th>
                                                    <th className={styles.width30Percent}>Bio</th>
                                                    <th>Messages Count</th>
                                                    <th>Quality Score</th>
                                                    <th>Recent Vote Date</th>
                                                    <th className={styles.width5Percent}>
                                                        No. of Positive Messages
                                                    </th>
                                                    <th className={styles.width5Percent}>No. of Mistakes</th>
                                                </tr>
                                                </thead>
                                                <tbody>{employments?.map(this.renderDetailsRow)}</tbody>
                                            </Table>
                                        </Row>
                                    </>
                                )}
                            </>
                        )}

                        <Row>
                            {loadingAttributes ? (
                                <div className={styles.expertDetailsLoader}>
                                    <Loading height={150} />
                                </div>
                            ) : (
                                <UserAttributes attributes={this.props.attributes} userId={this.props.match.params.userId}/>
                            )}
                        </Row>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    const {employment: {employments, loading,employmentMetrics,metricsLoading}, attributes: {attributes, loadingAttributes}} = state;
    return {
        employmentData: employments,
        attributes,
        employmentMetrics,
        loading,
        loadingAttributes,
        metricsLoading,
    };
}

const expertDetails = connect(mapStateToProps)(ExpertDetails);
export { expertDetails as ExpertDetails };
